import moment from "moment";
import React from "react";

export default function ProjectCard({ project, setProjectId }) {
  return (
    <div
      onClick={() => setProjectId(project.id)}
      className="flex-1 shadow-sm shadow-gray-400 p-4 mr-1 cursor-pointer rounded-md bg-white w-full"
    >
      <div className="flex flex-row justify-between items-center">
        <span className="flex flex-row space-x-2">
          {project?.title !== "Standalone Project" && (
            <span className="p-4 h-12 bg-[#2EBAA3] text-white flex justify-center items-center rounded-lg">
              {project?.title.split("")[0].toUpperCase()}
            </span>
          )}
          <span className="flex flex-col justify-center">
            <span
              className="capitalize text-ellipsis overflow-hidden"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {project.title}
            </span>
            {project.createdAt ? (
              <span className="text-sm text-gray-700">
                {moment.utc(project.createdAt).format("DD-MM-YYYY")}
              </span>
            ) : null}
          </span>
        </span>
      </div>
      {project.description && (
        <div className="mt-5">
          <span>Description:</span>
          <p
            className="text-sm text-gray-700 mt-1 text-ellipsis overflow-hidden"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
            }}
          >
            {project.description}
          </p>
        </div>
      )}
    </div>
  );
}
